import addClasses from './addClasses';
import removeClasses from './removeClasses';

export default { addClasses, removeClasses };



// WEBPACK FOOTER //
// ../src/components/core/classes/index.js